import { render, staticRenderFns } from "./TablePopup.vue?vue&type=template&id=6b88d272&scoped=true&"
import script from "./TablePopup.vue?vue&type=script&lang=js&"
export * from "./TablePopup.vue?vue&type=script&lang=js&"
import style0 from "./TablePopup.vue?vue&type=style&index=0&id=6b88d272&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b88d272",
  null
  
)

export default component.exports